export type { OntologyEntry, Dimension } from './types.js';
export { DIMENSIONS, isValidDimension } from './types.js';
export { OntologyRegistry } from './registry.js';
export { slugify, toSelectOptions, buildTree } from './helpers.js';
export type { SelectOption, TreeNode } from './helpers.js';

// Dimension data
export { regions } from './dimensions/regions.js';
export { countries } from './dimensions/countries.js';
export { industries } from './dimensions/industries.js';
export { securityDomains } from './dimensions/security-domains.js';
export { compliance } from './dimensions/compliance.js';
export { companySizes } from './dimensions/company-sizes.js';
export { deploymentModels } from './dimensions/deployment-models.js';
export { pricingTiers } from './dimensions/pricing-tiers.js';
export { severity } from './dimensions/severity.js';
export { sourceTiers } from './dimensions/source-tiers.js';
export { storyConfidence } from './dimensions/story-confidence.js';
export { languages } from './dimensions/languages.js';
export { contentTypes } from './dimensions/content-types.js';
export { contentSections } from './dimensions/content-sections.js';
export { contentCategories } from './dimensions/content-categories.js';
export { articleConfidence } from './dimensions/article-confidence.js';
export { vendorUpdateSubtypes } from './dimensions/vendor-update-subtypes.js';

// Pre-built registry with all static dimensions
import { regions } from './dimensions/regions.js';
import { countries } from './dimensions/countries.js';
import { industries } from './dimensions/industries.js';
import { securityDomains } from './dimensions/security-domains.js';
import { compliance } from './dimensions/compliance.js';
import { companySizes } from './dimensions/company-sizes.js';
import { deploymentModels } from './dimensions/deployment-models.js';
import { pricingTiers } from './dimensions/pricing-tiers.js';
import { severity } from './dimensions/severity.js';
import { sourceTiers } from './dimensions/source-tiers.js';
import { storyConfidence } from './dimensions/story-confidence.js';
import { languages } from './dimensions/languages.js';
import { contentTypes } from './dimensions/content-types.js';
import { contentSections } from './dimensions/content-sections.js';
import { contentCategories } from './dimensions/content-categories.js';
import { articleConfidence } from './dimensions/article-confidence.js';
import { vendorUpdateSubtypes } from './dimensions/vendor-update-subtypes.js';
import { OntologyRegistry } from './registry.js';

export const registry = new OntologyRegistry([
  ...regions,
  ...countries,
  ...industries,
  ...securityDomains,
  ...compliance,
  ...companySizes,
  ...deploymentModels,
  ...pricingTiers,
  ...severity,
  ...sourceTiers,
  ...storyConfidence,
  ...languages,
  ...contentTypes,
  ...contentSections,
  ...contentCategories,
  ...articleConfidence,
  ...vendorUpdateSubtypes,
]);
